import { render, staticRenderFns } from "./ZonePartsList.vue?vue&type=template&id=87e4448c&scoped=true"
import script from "./ZonePartsList.vue?vue&type=script&lang=js"
export * from "./ZonePartsList.vue?vue&type=script&lang=js"
import style0 from "./ZonePartsList.vue?vue&type=style&index=0&id=87e4448c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e4448c",
  null
  
)

export default component.exports